import { InMemoryCache } from "@apollo/client";

export default function GetApacheCache(cacheList) {
  return new InMemoryCache({
    addTypename: false,
    typePolicies: {
      Query: {
        fields: {
          ...cacheList,
        },
      },
    },
  });
}
